// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-copy-js": function componentSrcPages404CopyJs() {
    return import("./../../src/pages/404 copy.js"
    /* webpackChunkName: "component---src-pages-404-copy-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-auth-login-js": function componentSrcPagesAuthLoginJs() {
    return import("./../../src/pages/auth/login.js"
    /* webpackChunkName: "component---src-pages-auth-login-js" */
    );
  },
  "component---src-pages-auth-logout-js": function componentSrcPagesAuthLogoutJs() {
    return import("./../../src/pages/auth/logout.js"
    /* webpackChunkName: "component---src-pages-auth-logout-js" */
    );
  },
  "component---src-pages-auth-register-js": function componentSrcPagesAuthRegisterJs() {
    return import("./../../src/pages/auth/register.js"
    /* webpackChunkName: "component---src-pages-auth-register-js" */
    );
  },
  "component---src-pages-auth-reset-js": function componentSrcPagesAuthResetJs() {
    return import("./../../src/pages/auth/reset.js"
    /* webpackChunkName: "component---src-pages-auth-reset-js" */
    );
  },
  "component---src-pages-blog-js": function componentSrcPagesBlogJs() {
    return import("./../../src/pages/blog.js"
    /* webpackChunkName: "component---src-pages-blog-js" */
    );
  },
  "component---src-pages-checkout-js": function componentSrcPagesCheckoutJs() {
    return import("./../../src/pages/checkout.js"
    /* webpackChunkName: "component---src-pages-checkout-js" */
    );
  },
  "component---src-pages-dashboard-js": function componentSrcPagesDashboardJs() {
    return import("./../../src/pages/dashboard.js"
    /* webpackChunkName: "component---src-pages-dashboard-js" */
    );
  },
  "component---src-pages-docs-js": function componentSrcPagesDocsJs() {
    return import("./../../src/pages/docs.js"
    /* webpackChunkName: "component---src-pages-docs-js" */
    );
  },
  "component---src-pages-editor-collection-js": function componentSrcPagesEditorCollectionJs() {
    return import("./../../src/pages/editor/collection.js"
    /* webpackChunkName: "component---src-pages-editor-collection-js" */
    );
  },
  "component---src-pages-editor-view-js": function componentSrcPagesEditorViewJs() {
    return import("./../../src/pages/editor/view.js"
    /* webpackChunkName: "component---src-pages-editor-view-js" */
    );
  },
  "component---src-pages-editor-workflow-js": function componentSrcPagesEditorWorkflowJs() {
    return import("./../../src/pages/editor/workflow.js"
    /* webpackChunkName: "component---src-pages-editor-workflow-js" */
    );
  },
  "component---src-pages-features-js": function componentSrcPagesFeaturesJs() {
    return import("./../../src/pages/features.js"
    /* webpackChunkName: "component---src-pages-features-js" */
    );
  },
  "component---src-pages-help-js": function componentSrcPagesHelpJs() {
    return import("./../../src/pages/help.js"
    /* webpackChunkName: "component---src-pages-help-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-marketplace-js": function componentSrcPagesMarketplaceJs() {
    return import("./../../src/pages/marketplace.js"
    /* webpackChunkName: "component---src-pages-marketplace-js" */
    );
  },
  "component---src-pages-package-js": function componentSrcPagesPackageJs() {
    return import("./../../src/pages/package.js"
    /* webpackChunkName: "component---src-pages-package-js" */
    );
  },
  "component---src-pages-pricing-js": function componentSrcPagesPricingJs() {
    return import("./../../src/pages/pricing.js"
    /* webpackChunkName: "component---src-pages-pricing-js" */
    );
  },
  "component---src-pages-service-js": function componentSrcPagesServiceJs() {
    return import("./../../src/pages/service.js"
    /* webpackChunkName: "component---src-pages-service-js" */
    );
  },
  "component---src-pages-settings-js": function componentSrcPagesSettingsJs() {
    return import("./../../src/pages/settings.js"
    /* webpackChunkName: "component---src-pages-settings-js" */
    );
  },
  "component---src-pages-subscribe-js": function componentSrcPagesSubscribeJs() {
    return import("./../../src/pages/subscribe.js"
    /* webpackChunkName: "component---src-pages-subscribe-js" */
    );
  },
  "component---src-pages-welcome-js": function componentSrcPagesWelcomeJs() {
    return import("./../../src/pages/welcome.js"
    /* webpackChunkName: "component---src-pages-welcome-js" */
    );
  },
  "component---src-templates-doc-template-js": function componentSrcTemplatesDocTemplateJs() {
    return import("./../../src/templates/docTemplate.js"
    /* webpackChunkName: "component---src-templates-doc-template-js" */
    );
  },
  "component---src-templates-info-template-js": function componentSrcTemplatesInfoTemplateJs() {
    return import("./../../src/templates/infoTemplate.js"
    /* webpackChunkName: "component---src-templates-info-template-js" */
    );
  }
};